import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { McticHttpClient } from '@mctic/ng-core';
import { TipoMedidaAplicada } from '../shared/model/tipo-medida-aplicada.model';

@Injectable({
  providedIn: 'root'
})
export class TipoMedidaAplicadaService {

  private readonly endpoint = "sepin-backend/rest/tipo-medidas-aplicadas";

  constructor(private http: McticHttpClient) { }

  listar(): Observable<TipoMedidaAplicada[]> {
    return this.http.get<TipoMedidaAplicada[]>(`${this.endpoint}`);
  }
}
